export default function FilterField({ label, children, width = '140px' }) {
  return (
    <div className="flex flex-col gap-1" style={{ width }}>
      <label className="text-[10px] uppercase tracking-wider text-muted-foreground">
        {label}
      </label>
      <div className="h-8">
        {children}
      </div>
    </div>
  );
}
